import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Typography, TableCell, Box } from "@mui/material";
import ArrowUpIcon from "../../../assets/icons/ArrowUpIcon";
import ArrowDownIcon from "../../../assets/icons/ArrowDownIcon";
import CompareArrowVerticalIcon from "../../../assets/icons/CompareArrowVerticalIcon";

export default function CustomizedTableHeaderCell({
  index,
  column,
  columnWidths,
  lastColumnWidth
}) {
  const [filterDisplay, setFilterDisplay] = useState("none");
  const [sortDisplay, setSortDisplay] = useState("none");
  const [isFiltered, setIsFiltered] = useState(false);

  const getSortArrow = useCallback(() => {
    if (column.isSorted && column.isSortedDesc) {
      return <span style={{ display: "inline-flex", alignItems: "center" }}>
        <ArrowDownIcon sx={{ fontSize: "20px", color: "black_solid.60" }} />
        <Typography variant="subhead2" color="black_solid.60">{column.sortedIndex > 0 ? column.sortedIndex + 1 : null}</Typography>
      </span>;
    } else if (column.isSorted && !column.isSortedDesc) {
      return <span style={{ display: "inline-flex", alignItems: "center" }}>
        <ArrowUpIcon sx={{ fontSize: "20px", color: "black_solid.60" }} />
        <Typography variant="subhead2" color="black_solid.60">{column.sortedIndex > 0 ? column.sortedIndex + 1 : null}</Typography>
      </span>;
    } else {
      return <span style={{ display: sortDisplay, alignItems: "center" }}>
        <CompareArrowVerticalIcon sx={{ fontSize: "20px", color: "black_solid.60" }} />
      </span>;
    }
  }, [column.isSorted, column.isSortedDesc, column.sortedIndex, sortDisplay]);

  useEffect(() => {
    if (column.filterValue || column.showFilter) {
      setFilterDisplay("inline-flex");
    } else {
      setFilterDisplay("none");
    }
    setIsFiltered(!!column.filterValue);
  }, [column.filterValue, column.showFilter]);

  return (
    <TableCell
      component="div"
      onMouseEnter={() => {
        column.canSort && !column.sortDisabled && setSortDisplay("inline-flex");
        setFilterDisplay("inline-flex");
      }}
      onMouseLeave={() => {
        setSortDisplay("none");
        !isFiltered && !column.showFilter && setFilterDisplay("none");
      }}
      sx={{
        minWidth: columnWidths[index],
        backgroundColor: "white_opacity.100",
        borderRight: column.Header && "1px solid",
        borderBottom: "2px solid",
        borderColor: "black_solid.60",
        boxSizing: "border-box",
        padding: "8px 4px",
        "&:hover": { backgroundColor: "primary.10" },
        "&:last-child": { minWidth: lastColumnWidth(index) }
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: "20px" }}>
        <Typography
          variant="button2"
          color="black_solid.80"
          {...column.getHeaderProps(column.getSortByToggleProps())}
          sx={{ maxWidth: "max-content" }}
          onClick={(e) => {
            e.shiftKey = e.altKey;
            column.getHeaderProps(column.getSortByToggleProps()).onClick(e);
          }}
        >
          {column.render("Header")}
        </Typography>
        <Box sx={{ display: "inline-flex", alignItems: "center" }}>
          <Box sx={{ display: filterDisplay }}>{column.canFilter ? column.render("Filter") : null}</Box>
          {getSortArrow()}
        </Box>
      </Box>
    </TableCell>
  );
}

CustomizedTableHeaderCell.propTypes = {
  index: PropTypes.number.isRequired,
  column: PropTypes.object.isRequired,
  columnWidths: PropTypes.array.isRequired,
  lastColumnWidth: PropTypes.func
};